import React, { useState } from "react";

//UI Material
import {
  Alert,
  AlertTitle,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import {
  ArrowForwardIosTwoTone,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";

//Components
import ElcoLogo from "../Components/Logos/ElcoLogo";

//Helpers
import { hostPath } from "../Constants/constants";
import { redirectToHome } from "../Helpers/redirections";

export default function Login() {
  // ==========>Component States<==========
  //State for the message when some error occurs
  const [authError, setAuthError] = useState("");
  //State for showing password
  const [showPassword, setShowPassword] = useState(false);
  //State for userEmail
  const [userEmail, setUserEmail] = useState("");
  //State for password
  const [password, setPassword] = useState("");
  //State for show the login loader
  const [isLoading, setIsLoading] = useState(false);

  // ==========>Component Functions<==========

  //Handler for password visibility
  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  //Function for generate login button status
  const selectButtonStatus = () => {
    if (isLoading) {
      return <CircularProgress />;
    } else {
      return (
        <Button
          size="small"
          variant="contained"
          color="secondary"
          endIcon={<ArrowForwardIosTwoTone />}
          sx={{ color: "white" }}
          onClick={getToken}
        >
          {"Iniciar Sesión"}
        </Button>
      );
    }
  };

  //Function to generate error alert in login
  const generateErrorAlertInLogin = () => {
    if (authError) {
      return (
        <Alert variant="filled" severity="error" sx={{ maxWidth: "250px" }}>
          <AlertTitle>
            <Typography component={"span"}>{`Error: ${authError}`}</Typography>
          </AlertTitle>
        </Alert>
      );
    } else {
      return null;
    }
  };

  //Function to get token
  const getToken = async () => {
    try {
      setIsLoading(true);
      const requestResponse = await fetch(hostPath + `/users/sign-in`, {
        method: "POST",
        body: JSON.stringify({ userEmail, password }),
        headers: {
          "Content-type": "application/json",
        },
      });
      const jsonResponse = await requestResponse.json();
      localStorage.setItem("token", JSON.stringify(jsonResponse.token));
      localStorage.setItem("userData", JSON.stringify(jsonResponse.userData));
      setAuthError(jsonResponse.description);
      if (jsonResponse.status === "ok") {
        setTimeout(() => {
          redirectToHome();
        }, 3000);
        localStorage.setItem("userEmail", JSON.stringify(userEmail));
        localStorage.setItem("password", JSON.stringify(password));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setAuthError("Error de conexión, intente nuevamente.");
      setIsLoading(false);
    }
  };

  // ==========>Component<==========
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      textAlign="center"
      spacing={2}
      sx={{ p: 2, height: "90vh" }}
    >
      <Grid item xs={12}>
        <ElcoLogo height="50px" />
      </Grid>
      <Grid item xs={12}>
        <Typography fontWeight="bold" variant="h5">
          Iniciar Sesión
        </Typography>
      </Grid>
      <Grid item xxs={12}>
        {generateErrorAlertInLogin()}
      </Grid>
      <Grid item xs={12}>
        <Stack justifyContent="center" alignItems="center" spacing={1}>
          <Typography>Correo Electrónico</Typography>
          <TextField
            value={userEmail}
            onChange={(e) => {
              setUserEmail(e.target.value.trim());
            }}
            inputProps={{ style: { textTransform: "lowercase" } }}
            placeholder="Ingrese su correo"
            color="secondary"
            sx={{ width: "275px" }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Stack justifyContent="center" alignItems="center" spacing={1}>
          <Typography>Contraseña</Typography>
          <TextField
            sx={{ width: "275px" }}
            placeholder="Ingrese su contraseña"
            color="secondary"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            type={showPassword ? "text" : "password"}
            InputProps={{
              endAdornment: (
                <IconButton
                  aria-label="toggle password visibility"
                  position="start"
                  onClick={handleShowPassword}
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              ),
            }}
          />
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Button
          sx={{ fontSize: "10px" }}
          variant="text"
          color="secondary"
          onClick={() => {
            window.location.assign("/sendRecoverEmail");
          }}
        >
          {"¿Has olvidado la contraseña?"}
        </Button>
      </Grid>
      <Grid item xs={12}>
        {selectButtonStatus()}
      </Grid>
    </Grid>
  );
}
